module.exports = __webpack_public_path__ + "img/leftrightpanelreveal.448e7dcc.png";